import { ViewModel,View, ObservableArray } from "binder"
import  { ReceiptBillDetailView } from "./receiptBillDetail-view"
import { ServerConnection } from "src/server/serverConnection";
import moment from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class ReceiptBillDetailViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.lineItems = ObservableArray.create<BillLineItem>();
    }
    closePopup(result: boolean = false) {
       
    }
    GetDefaultView(): View <ViewModel> {
        return new ReceiptBillDetailView();
    }
    public getTypeId(): string {
        return "VM-BBC00442-3CEB-43F6-9CD0-CF134922F8B0"
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName; } private _warehouseName: string;
    public set partyName(v: string) { this._partyName = v; } public get partyName(): string { return this._partyName; } private _partyName: string;
    public set billNo(v: string) { this._billNo = v; } public get billNo(): string { return this._billNo; } private _billNo: string;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime; } private _creationTime: moment.Moment;
    public set lineItems(v: ObservableArray<BillLineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<BillLineItem> { return this._lineItems; } private _lineItems: ObservableArray<BillLineItem>;
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    async loadById(billId: string) {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetBillDetail',{
            BillId : billId
        });
        this.id = result.Id;
        this.warehouseName = result.WarehouseName;
        this.partyName = result.PartyName;
        this.creationTime = moment.utc(result.Time);
        this.billNo = result.No;
        this.lineItems.update(...result.LineItems.map((q, i) => {
            let r = new BillLineItem(this);
            r.rowNumber = i + 1;
            r.id = q.LineItemId;
            r.unitName = q.UnitName;
            r.productName = q.ProductName;
            r.productCode = q.ProductCode;
            r.productCarModel = q.ProductCarModel;
            r.feePrice = q.FeePrice;
            r.amount = q.Amount;
            r.meanPrice = q.MeanPrice;
            r.description = q.Description;
            return r;
        }));
        
    }
    
    back() {
        this.closePopup();
    }

    async confirm() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('Complex/WarehouseServices/SetReceiptPrice', {
                BillId: this.id,
                Prices: this.lineItems.map(q => {
                return {
                    LineItemId: q.id,
                    FeePrice: q.feePrice
                }})
            });
            if(result.IsSuccessful){
                await this.messageBoxConfirmSuccess("اطلاعات با موفقیت ذخیره شد.", "ثبت قیمت رسید انبار");
                this.closePopup(true);
            }
            else{
                await this.messageBoxConfirmWarning("امکان ثبت قیمت رسید وجود ندارد.",'خطا');
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

}

export class BillLineItem extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber; } private _rowNumber: number;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount; } private _amount: number;
    public set feePrice(v: number) { this._feePrice = v; } public get feePrice(): number { return this._feePrice; } private _feePrice: number;
    public set meanPrice(v: number) { this._meanPrice = v; } public get meanPrice(): number { return this._meanPrice; } private _meanPrice: number;
    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName; } private _unitName: string;
    public set description(v: string) { this._description = v; } public get description(): string { return this._description;} private _description: string;
    
}
